import api from './api';

export type VisitSource = 'ads' | 'organic' | 'referral' | 'direct';

export interface SiteDailyStat {
    date: string;
    totalViews: number;
    uniqueVisitors: number;
    bySource: Record<VisitSource, number>;
}

export interface SiteAnalyticsResponse {
    startDate: string;
    endDate: string;
    daily: SiteDailyStat[];
    totals: { totalViews: number; uniqueVisitors: number; bySource: Record<VisitSource, number> };
}

export const siteAnalyticsApi = {
    async getSiteStats(startDate: string, endDate: string): Promise<SiteAnalyticsResponse> {
        try {
            const response = await api.get('/admin/analytics/site', { params: { startDate, endDate } });
            return response.data;
        } catch (error: any) {
            throw new Error(error.response?.data?.error || 'Ziyaretçi istatistikleri yüklenemedi');
        }
    },
};
